export default __webpack_public_path__ + "static/media/iNovel-ios.d70be2cc.png";